import React from 'react'
import SignupForm from '../common/SignupForm'

function Signup(props) {
  return <SignupForm />
}

export default Signup
